import React from 'react';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { Text, TitleFeatured } from '@/components/typography';
import { LayoutInternal } from '@/layout';
import { urlPacotes } from '@/config/url';
import { Grid } from '@/components/grid';
import { usePacotesListContext } from './context/PacotesListContext';
import CardProduct from '@/features/pacote/components/CardProduct/CardProduct';
import { ProductList } from './PacotesList.styles';
import { FilterBar, TravelTypeHeading, TravelTypeMenu } from '@/features/pacote/PacotesList/components';
import CardCurrencyInfo from '@/features/pacote/components/CardCurrencyInfo/CardCurrencyInfo';
import CreateJourney from '@/components/cta/CreateJourney';
import Sticky from '@/components/sticky/Sticky';
import { useTranslations } from 'next-intl';

const PacotesList = () => {
  const t = useTranslations('Pacote');
  const { data } = usePacotesListContext();
  const { destino, pacotes, queryTravelType, travelType } = data;

  const breadcrumbs: BreadcrumbType = [];

  if (queryTravelType && travelType?.id === queryTravelType) {
    breadcrumbs.push({ path: '/viagens', text: t('Viagens') });
    breadcrumbs.push({ path: `/viagens/${travelType.slug}`, text: travelType.title });
    breadcrumbs.push({ text: destino.title || '' });
  } else {
    breadcrumbs.push({ path: urlPacotes(), text: t('Pacotes') });
    breadcrumbs.push({ path: urlPacotes(destino.slug), text: destino.title });
  }

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} mediaCover={destino?.cover}>
      <WhitePaper col={12}>
        <TitleFeatured
          as="h1"
          title={`${t('Pacotes de Viagem')} ${destino?.title}`}
          description={destino.description_packages}
        />
      </WhitePaper>

      <Grid item col={12} col-sm={12} col-lg={3} as="aside">
        <Sticky top={5} zIndex={10}>
          <TravelTypeMenu />
          {(pacotes.length && <CreateJourney visibility={{ hide: 'sm' }} />) || null}
        </Sticky>
      </Grid>

      <Grid item col={12} col-sm={12} col-lg={9}>
        <WhitePaper>
          <TravelTypeHeading />
          <FilterBar />
          <ProductList>
            {(pacotes.length && pacotes.map((pacote, index) => <CardProduct key={pacote.uuid} pacote={pacote} />)) || (
              <Text>{t(`Não há pacotes para o destino {title} no momento`, { title: destino.title })}.</Text>
            )}
          </ProductList>
        </WhitePaper>
        <CreateJourney size="large" visibility={{ min: 'sm' }} />
        <CardCurrencyInfo />
      </Grid>
    </LayoutInternal>
  );
};

export default PacotesList;
